import React from 'react';

const Facebook = (props) => (
	<svg
		viewBox="0 0 30 31"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M30.0001 15.9282C30.0001 7.64395 23.2843 0.928223 15.0001 0.928223C6.71578 0.928223 6.10352e-05 7.64395 6.10352e-05 15.9282C6.10352e-05 23.415 5.48531 29.6207 12.6563 30.746V20.2642H8.84772V15.9282H12.6563V12.6235C12.6563 8.86416 14.8958 6.7876 18.322 6.7876C19.9627 6.7876 21.6797 7.08057 21.6797 7.08057V10.772H19.7883C17.9251 10.772 17.3438 11.9283 17.3438 13.1157V15.9282H21.504L20.8389 20.2642H17.3438V30.746C24.5148 29.6207 30.0001 23.415 30.0001 15.9282Z"
			fill="#6B6279"
		/>
	</svg>
)

export default Facebook;
